'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/_react-dom@15.6.2@react-dom/index.js
// module id = 64
// module chunks = 0